import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { Grid } from '@mui/material'
import useStylesSeeMoreOrganization from './useStyleSeeMoreOrganization'
import CloseIcon from '@mui/icons-material/Close'

export default function StepperSeeMore ({
  setstateSeeMore,
  item,
  suscriber,
  setLoading
}) {
  const classes = useStylesSeeMoreOrganization()

  const getScopeStatus = () => {
    if (item.product?.product_scopes && item.product?.product_scopes.length) {
      if (item.product?.product_scopes[0].is_active) {
        return 'Activo'
      } else {
        return 'No activo'
      }
    } else {
      return null
    }
  }

  const SeeMoreOrganizationOfID = ({ item }) => {
    return (
      item && (
        <>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                ID de la cuenta ejecutiva referente:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {item.account_executive_ref_id || '- -'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Estado de la suscripción:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {item.is_active ? 'Activo' : 'No activo' || '- -'}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Fecha de inicio de la suscripción:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {item.subscription_start_date || '- -'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Fecha de finalización de la suscripción:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {item.subscription_finish_date || '- -'}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                ID de suscripción del producto:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {item.product_subscription_id || '- -'}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>Producto:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {item.product?.product_name || '- -'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Código del producto:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {item.product?.product_code || '- -'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>ID del producto:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {item.product_id || '- -'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>Tipo:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {item.product?.product_type?.product_type_name || '- -'}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Máximo de accesos:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {item.product?.product_scopes &&
                item.product?.product_scopes.length > 0
                  ? item.product?.product_scopes[0].product_max_access_count
                  : '- -'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Máximo de usuarios:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {item.product?.product_scopes &&
                item.product?.product_scopes.length > 0
                  ? item.product?.product_scopes[0].product_max_user_count
                  : '- -'}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Estado del producto:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {getScopeStatus() || '- -'}
              </Typography>
            </Grid>
          </Grid>
        </>
      )
    )
  }

  return (
    <Box className={classes.backgroundBox}>
      <div
        style={{
          width: '100%',
          display: 'flex',
          padding: '8px 0px 8px 0px',
          justifyContent: 'space-between',
          boxShadow: '0px 1px 1px #EAEAEA',
          color: '#8C8C8C'
        }}
      >
        <Typography className={classes.seeMoreTypography}>
          Detalles de la suscripción asociada a{' '}
          {suscriber && suscriber.subscriber_name}
        </Typography>
        <CloseIcon
          style={{
            cursor: 'pointer',
            paddingRight: 10,
            fontSize: '1.5rem'
          }}
          onClick={() => {
            setstateSeeMore(false)
          }}
        />
      </div>
      <Box className={classes.mainBox}>
        <SeeMoreOrganizationOfID item={item} />
      </Box>

      <ButtonClose setstateSeeMore={setstateSeeMore} />
    </Box>
  )
}

function ButtonClose ({ setstateSeeMore }) {
  const classes = useStylesSeeMoreOrganization()

  return (
    <Box className={classes.closeButton}>
      <Box
        className={classes.closeButtonStyle}
        sx={{
          '&:hover': {
            bgcolor: '#1BF57F'
          }
        }}
      >
        <Typography
          onClick={() => {
            setstateSeeMore(false)
          }}
          className={classes.closeButtonTypography}
        >
          Cerrar
        </Typography>
      </Box>
    </Box>
  )
}
